import { Grid, Typography } from '@methanesat/ui-components';

import { useTranslate } from '../../../../hooks';

export const InfrastructureModalHeader = ({
    layerName,
    operatorName,
    sourceDate,
    hideOperator
}: {
    layerName?: string;
    operatorName?: string;
    sourceDate?: string;
    hideOperator?: boolean;
}) => {
    const t = useTranslate();

    return (
        <Grid size="grow">
            {layerName && (
                <Grid size="grow">
                    <Typography variant="h5" display="inline">
                        {layerName}
                    </Typography>
                    <Typography variant="caption" component="span" marginLeft={1} sx={{ verticalAlign: 'text-top' }}>
                        ({t('emissionsMapPage.mapModals.common.featureTypeLabel')})
                    </Typography>
                </Grid>
            )}
            {/* Hidden when used from the error boundary fallback */}
            {!hideOperator &&
                (operatorName ? (
                    <>
                        <Typography variant="h5" sx={{ display: 'inline' }}>
                            {operatorName.toUpperCase()}
                        </Typography>
                        <Typography
                            variant="caption"
                            marginLeft={1}
                            sx={{ display: 'inline', verticalAlign: 'text-bottom' }}
                        >
                            ({t('emissionsMapPage.mapModals.infrastructure.operatorLabel')})
                        </Typography>
                    </>
                ) : (
                    <Typography variant="h5">
                        {t('emissionsMapPage.mapModals.infrastructure.unknownOperator').toUpperCase()}
                    </Typography>
                ))}
            {sourceDate && (
                <Grid size="auto">
                    <Typography variant="caption" fontStyle="italic">
                        {`${t('emissionsMapPage.mapModals.common.dataUpdatedLabel')}: ${sourceDate}`}
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};
